<template>
  <div class="reset-password auth">
    <terms-form
      :display-terms="!termsAccepted"
      @terms-accepted="termsAccepted=true"
    />
    <div class="container">
      <img
        src="../../assets/myvisionlink-rewards-light.svg"
        alt="VisionLink"
      >
      <transition name="fade">
        <div
          v-if="termsAccepted"
          class="card"
        >
          <input-field
            v-model="email"
            :editable="false"
            :value="email"
          >
            Email
          </input-field>
          <password-field
            :value="password"
            field-type="password"
            @input="evtPasswordChange"
          >
            Password
          </password-field>
          <password-field
            :value="verifyPassword"
            field-type="password"
            @input="evtVerifyPasswordChange"
          >
            Verify Password
          </password-field>
          <standard-button @click="resetPassword">
            Login
          </standard-button>
        </div>
      </transition>
      <va-modal
        v-if="showError"
        v-model="showError"
        title="Password Reset Failed"
        close-button
      >
        <div>{{ errorMessage }}</div>
        <standard-button @click="backToLogin">Return to Login screen</standard-button>
      </va-modal>
    </div>
  </div>
</template>

<script>
import StandardButton from "@/components/elements/StandardButton";
import InputField from "@/components/elements/InputField";
import PasswordField from "@/components/elements/PasswordField";
import TermsForm from "./TermsForm";
export default {
	name: "ResetPassword",
	components: {
		InputField,
		PasswordField,
		StandardButton,
		TermsForm
	},
	data() {
		return {
			email:null,
			code:null,
			termsAccepted: true,
			username: "",
			password: "",
			verifyPassword: "",
			showError: false,
			errorMessage: "XXX"
		}
	},
	mounted() {
		this.email = this.$route.params.email;
		this.code = this.$route.params.code;
		this.termsAccepted = this.$route.params.accepted == 1;
	},
	methods: {
		resetPassword(){
			if(this.password === this.verifyPassword){
				this.$apiManager.post("reset-password", {
					email: this.email,
					code:this.code,
					password: this.password
				}).then(
					(pack) => this.resetComplete(pack),
					() => this.resetFailed()
				);
			} else {
				this.errorMessage = "Password and password confirmation do not match.";
				this.showError = true;
			}
		},
		evtPasswordChange(newValue){
			if (typeof newValue === 'string') {
				this.password = newValue;
			}
		},
		evtVerifyPasswordChange(newValue){
			if (typeof newValue === 'string') {
				this.verifyPassword = newValue;
			}
		},
		resetComplete(pack){
			if(pack.data && pack.data.success){
				this.$apiManager.token = pack.data.token;
				if(pack.data.adminUrl){
					this.$apiManager.adminUrl = pack.data.adminUrl;
				}
				this.$apiManager.get("user").then(
					(pack) => this.userDataSuccess(pack),
					() => this.dataFailure(),
				);
			} else {
				this.resetFailed();
			}
		},
		userDataSuccess(pack){
			if(pack.data && pack.data.success){
				this.$dataDirectory.userData = pack.data;
				this.$router.push("/dashboard");
			} else {
				this.dataFailure();
			}
		},
		resetFailed(){
			this.errorMessage = "The link you followed is no longer valid. Please return to the Login screen and click 'Forgot Password'.";
			this.showError = true;
		},
		dataFailure(){
			this.errorMessage = "There was an issue communicating with the server. Please try again later.";
			this.showError = true;
		},
		backToLogin(){
			this.$router.push("/login");
		},
	}
}
</script>
<style lang="scss" scoped>
@import '@/scss/_auth.scss';

.reset-password{

	.card{
		max-width: 470px;
		border-radius: 15px;
		text-align: center;
		padding: 40px;
		position: relative;
		background-color: #FFFFFF;
	}
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>